import React, { useState, useEffect } from "react";
import AdminAppBody from "../../../../components/admin/AdminAppBody";
import PageHeading from "../../../../components/admin/common/PageHeading";
import { useParams, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import useApiCallHooks from "../../../../hooks/useApiCallHooks";
import { uiRoutes } from "../../../../routes/ui/uiRoutes";
const ProgramEdit = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [response, loading, error, callAPI, statusCode] = useApiCallHooks();
  const [isSet, setIsSet] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    image: null,
    image_url: "",
    duration: "",
    type: "",
    description: "",
    learning_points: "",
    age: "",
    activities: "",
    rating: "",
    tag: "DEV",
    curriculum: null,
    curriculum_url: "",
    price: "",
    _method: "PUT",
  });
  const [imagePreview, setImagePreview] = useState(null);
  useEffect(() => {
    callAPI("get", "admin/programs" + "/" + id);
  }, []);
  useEffect(() => {
    if (response?.data && !isSet) {
      setFormData(prev => ({
        ...prev,
        ...response.data,
        _method: "PUT",
      }));
      setIsSet(true);
    }
  }, [response]);
  useEffect(() => {
    if (statusCode === 202) {
      toast.success("Program updated successfully!");
      setTimeout(() => {
        navigate(uiRoutes.admin.program.list);
      }, 1000);
    }
  }, [statusCode]);
  const handleImageChange = (e) => {
    const file = e.target.files[0];
    setFormData({ ...formData, image: file });
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => setImagePreview(reader.result);
      reader.readAsDataURL(file);
    } else {
      setImagePreview(null);
    }
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    const submitData = new FormData();
    for (const key in formData) {
      submitData.append(key, formData[key]);
    }
    callAPI("post","admin/programs" + "/" + id, formData);
    };
    console.log(formData.image)
  return (
    <AdminAppBody
      loading={loading}
      content={
        <div className="container mt-5">
          <PageHeading title="Edit Program" subTitle="Edit the programs" />
          <div className="container card p-4 shadow-sm mt-3">
            <form onSubmit={handleSubmit} className="row g-3" encType="multipart/form-data">
              <h6>Edit Program Form</h6>
              {/* Name */}
              <div className="col-md-4">
                <label className="form-label">Name</label>
                <input
                  type="text"
                  className="form-control"
                  value={formData.name}
                  onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                />
                <span className="val-message">
                  {error?.message === "ValidationError" && error?.data?.name}
                </span>
              </div>
              {/* Image Upload */}
              <div className="col-md-4">
                <label className="form-label">Image Upload</label>
                <input
                  type="file"
                  accept="image/*"
                  className="form-control"
                  onChange={handleImageChange}
                />
                {imagePreview ? (
                  <img src={imagePreview} alt="Preview" className="mt-2" style={{ width: "100%", maxHeight: "200px", objectFit: "contain" }} />
                ) : formData?.image && (
                  <img src={formData?.image} alt="Current" className="mt-2" style={{ width: "100%", maxHeight: "200px", objectFit: "contain" }} />
                )}
                <span className="val-message">
                  {error?.message === "ValidationError" && error?.data?.image}
                </span>
              </div>
              {/* Duration */}
              <div className="col-md-4">
                <label className="form-label">Duration</label>
                <input
                  type="text"
                  className="form-control"
                  value={formData.duration}
                  onChange={(e) => setFormData({ ...formData, duration: e.target.value })}
                />
              </div>
              {/* Type */}
              <div className="col-md-4">
                <label className="form-label">Type</label>
                <select
                  className="form-select"
                  value={formData.type}
                  onChange={(e) => setFormData({ ...formData, type: e.target.value })}
                >
                  <option value="">Select Type</option>
                  <option value="student">Student</option>
                  <option value="kids">Kids</option>
                </select>
              </div>
              {/* Age */}
              <div className="col-md-4">
                <label className="form-label">Age Group</label>
                <input
                  type="text"
                  className="form-control"
                  value={formData.age}
                  onChange={(e) => setFormData({ ...formData, age: e.target.value })}
                />
              </div>
              {/* Activities */}
              <div className="col-md-4">
                <label className="form-label">Activities</label>
                <input
                  type="text"
                  className="form-control"
                  value={formData.activities}
                  onChange={(e) => setFormData({ ...formData, activities: e.target.value })}
                />
              </div>
              {/* Rating */}
              <div className="col-md-3">
                <label className="form-label">Rating</label>
                <input
                  type="number"
                  className="form-control"
                  min="0"
                  max="5"
                  step="0.1"
                  value={formData.rating}
                  onChange={(e) => setFormData({ ...formData, rating: e.target.value })}
                />
              </div>
              {/* Tag */}
              <div className="col-md-3">
                <label className="form-label">Tag</label>
                <input
                  type="text"
                  className="form-control"
                  value={formData.tag}
                  onChange={(e) => setFormData({ ...formData, tag: e.target.value })}
                />
              </div>
              {/* Price */}
              <div className="col-md-3">
                <label className="form-label">Price</label>
                <input
                  type="number"
                  className="form-control"
                  value={formData.price}
                  onChange={(e) => setFormData({ ...formData, price: e.target.value })}
                />
              </div>
              {/* Curriculum PDF */}
              <div className="col-md-3">
                <label className="form-label">Curriculum (PDF)</label>
                <input
                  type="file"
                  accept="application/pdf"
                  className="form-control"
                  onChange={(e) => setFormData({ ...formData, curriculum: e.target.files[0] })}
                />
                {formData.curriculum_url && (
                  <a
                    href={formData.curriculum_url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="d-block mt-2 text-primary"
                  >
                    View Existing Curriculum
                  </a>
                )}
                <span className="val-message">
                  {error?.message === "ValidationError" && error?.data?.curriculum}
                </span>
              </div>
              {/* Description */}
              <div className="col-md-6">
                <label className="form-label">Description</label>
                <textarea
                  className="form-control"
                  rows="2"
                  value={formData.description}
                  onChange={(e) => setFormData({ ...formData, description: e.target.value })}
                />
              </div>
              {/* Learning Points */}
              <div className="col-md-6">
                <label className="form-label">Learning Points</label>
                <textarea
                  className="form-control"
                  rows="2"
                  value={formData.learning_points}
                  onChange={(e) => setFormData({ ...formData, learning_points: e.target.value })}
                />
              </div>
              <div className="col-4 mt-5 mb-5">
                <button type="submit" className="btn btn-primary w-100">
                  Submit
                </button>
              </div>
            </form>
          </div>
        </div>
      }
    />
  );
};
export default ProgramEdit;